<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<p class="contentsHead">Contents</p>
<p class="toc" style="text-indent: 0em;"><a href="#/xhtml/frontmatter01">Prologue</a></p>
<p class="toc" style="text-indent: 0em;"><a href="#/xhtml/chapter01">Chapter 1</a></p>
<p class="toc" style="text-indent: 0em;"><a href="#/xhtml/chapter02">Chapter 2</a></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">Source Notes</span></p>
<p class="toc" style="text-indent: 0em;"><span href="#/xhtml/backmatter04" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?08ed12f4